<template>
  <div>
    <div class="header-pane">
      <div class="logo" @click="goThere('home');">
        <img :src="'/imgs/logo@3x.png'" alt=""/>
      </div>
      <div>
        <ul class="menu-box">
          <li class="menu-item">
            <Dropdown trigger="hover" placement="bottom">
              <div class="tag-container">
                <div
                    class="tag"
                    :class="{ active: activeTag === 'crypto' }"
                    @click="goThere('crypto')"
                >{{ $t("specialMenu.crypto") }}</div>
                <div
                    class="tag"
                    :class="{ active: activeTag === 'virtualCard' }"
                    @click="goThere('virtualCard')"
                >{{ $t("specialMenu.virtualCard") }}</div>
              </div>
            </Dropdown>
          </li>
          <li class="menu-item"
              v-for="el in $t('footerMenu')"
              :key="el.name"
              @mouseenter="openPopup(el.router)"
              @mouseleave="hidePopup">
            <span class="menu-item-title">{{ el.name }}</span>
            <div class="popup-box" v-if="isPopupVisible && currentName === el.router">
              <div class="title">{{ el.name }}</div>
              <div class="service-list">
                <div v-for="item in el.childList" :key="item.name" class="service-item">
                  <a @click="goThere(item.url)">{{ item.name }}</a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="dropdown">
        <button class="dropdown-button" @click="toggleDropdown">
          {{ getNameByValue(language) }}
          <span class="caret"><icon class="el-icon-arrow-down"></icon></span>
        </button>
        <div class="dropdown-content" v-if="showDropdown">
          <div
              v-for="(lang, index) in languages"
              :key="index"
              @click="changeLangEvent(lang.value)"
              class="dropdown-item"
          >
            {{ lang.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      currentName: undefined,
      activeTag: 'crypto',
      showDropdown: false,
      isPopupVisible: false,
      language: localStorage.getItem("locale") || "cn",
      languages: [
        {
          name: 'English',
          value: 'en'
        },
        {
          name: '简体中文',
          value: 'cn'
        },
        {
          name: '日本語',
          value: 'jpn'
        }
      ]
    };
  },
  methods: {
    getNameByValue(value) {
      console.log('language', this.language)
      const lang = this.languages.find(lang => lang.value === value);
      return lang ? lang.name : '';
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    goThere(router) {
      if (router === 'crypto' || router === 'virtualCard') {
        this.activeTag = router;
      }
      this.isPopupVisible = false;
      this.$router.push({name: router});
    },
    openPopup(name) {
      console.log('name', name)
      this.currentName = name;
      this.isPopupVisible = true;
    },
    hidePopup() {
      this.isPopupVisible = false;
    },
    changeLangEvent(value){
      localStorage.setItem("locale", value);
      this.$i18n.locale = localStorage.getItem("locale");
      this.language = value;
      location.reload();
      this.showDropdown = false;
    }
  },
  mounted() {
  },
  watch: {
    activeTag(newVal) {
      console.log('监听', newVal)
      this.$router.push({name: newVal});
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-select-dropdown {
  margin: 0;
  padding: 0;
  background: none;
}

.backstage {
  position: absolute;
  right: 30px;
  top: 35px;
  cursor: pointer;
}

.head-box {
  width: 100%;
  height: 82px;
  transition: all 0.5s ease-in-out;
}

.header-position {
  position: absolute;
  z-index: 9;
  color: #fff;
}

.header-pane {
  height: 82px;
  margin: 0 70px;
  display: flex;
  align-items: center;

  .text {
    width: 310px;

    img {
      width: 100%;
      height: 60px;
    }
  }

  .logo {
    height: 82px;
    line-height: 82px;
    cursor: pointer;

    img {
      vertical-align: middle;
      width: 100px;
    }
  }

  .menu-box {
    display: flex;

    .menu-item-actived {
      border-bottom: 2px solid #fff;
    }

    .menu-item {
      height: 82px;
      line-height: 82px;
      margin: 0 25px;
      position: relative;

      .menu-item-title {
        font-weight: 400;
        cursor: pointer;
        font-size: 18px;
      }

      .actived {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 56px;
        height: 2px;
        background: #fff;
      }

      &:hover {
        .actived {
          display: inline-block !important;
        }

        border-bottom: 2px solid #fff;
      }
    }
  }
}

.tag-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 16px;
  height: 32px;
  padding: 0 4px;
  background-color: #ebebeb;
}

.tag {
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  cursor: pointer;

  &.active {
    background-color: #2052F3;
    color: white;
  }

  &:not(.active) {
    color: black;
  }
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  border: none;
  background-color: transparent;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: none; /* 去除聚焦时可能出现的阴影 */
}

/* 去掉点击后的轮廓线 */
.dropdown-button:focus {
  outline: none;
}

.caret {
  margin-left: 10px;
}

.dropdown-content {
  position: absolute;
  left: 0;
  top: 100%; /* 紧贴按钮下方 */
  display: block;
  background-color: #fff;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid #ddd;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
  border-radius: 8px;
}

.dropdown-item {
  padding: 10px 20px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}

.popup-box {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 50px;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  width: 80%;
  height: auto;
  border-radius: 20px;
  .title {
    font-size: 48px;
    font-weight: bold;
    color: #0c0c0c;
  }
  .service-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    .service-item {
      color: #0c0c0c;
      width: 33.33%;
      padding-right: 50px;
    }
    .service-item h3 {
      font-size: 24px;
    }
    .service-item p {
      font-size: 16px;
      line-height: 1.5;
      white-space: normal;
      word-wrap: break-word;
    }
    .service-item a {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.5;
      white-space: normal;
      word-wrap: break-word;
      color: #0c0c0c;
    }
  }
}

.popup-box-pr {
  position: absolute;
  left: 0;
  top: 100%; /* 紧贴按钮下方 */
  display: block;
  background-color: #fff;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid #ddd;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
  border-radius: 8px;
}
</style>
